module.exports = __webpack_public_path__ + "static/media/1.7_preview.8e06f58c.png";